export default {
  confirm: 'Confirmer',
  title: 'Offres éligibles',
};
